import {CardActions} from '@mui/material';
import styled from 'styled-components';

const StyledCardActions = styled(CardActions)`
	padding: 0 8px 16px;
	justify-content: flex-end;
`;

export {StyledCardActions};
